import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

export const expedienteServicioService = {
  getExpedientesServicios,
  postExpedienteServicio,
  getExpedienteServicioById,
  getExcel,
  putExpedienteServicio,
};

function getExpedientesServicios(pagination, filters) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-servicios`;
  const pagination_service = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };

  const params = new URLSearchParams({ ...pagination_service, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function postExpedienteServicio(request) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-servicios`;
  return axios.post(urlPath, request);
}

function getExpedienteServicioById(id) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-servicios/${id}`;
  return axios.get(urlPath);
}

function getExcel(filters) {
  const axios = createAxiosHeaders();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `/franquicia/${franquicia._id}/expedientes-servicios/excel?`;

  const params = new URLSearchParams({ ...filters, ...{ limit: 2000 } });
  urlPath += `${params.toString()}`;

  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}

function putExpedienteServicio(id, request) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-servicios/${id}`;
  return axios.put(urlPath, request);
}
